// removed by extract-text-webpack-plugin
module.exports = {"layout":"layout___3Pyz6","main":"main___1OIFf","fullscreen":"fullscreen___1FHam"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.module.scss
// module id = 2738
// module chunks = 0